import { Box } from '@mui/material';
import ButtonWrapper from '../../shared/formUtilities/useButton';
import TextWrapper from '../../shared/formUtilities/useTextWrapper';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { Link } from 'react-router-dom';

export const UnauthorizedAccess = () => {
	return (
		<Box className="flex flex-col light-bg flex-auto justify-center items-center h-full">
			<TextWrapper
				type="h1"
				text="401"
				color="error"></TextWrapper>
			<TextWrapper
				type="h4"
				classList="caption"
				text="Unauthorized"></TextWrapper>
			<TextWrapper
				type="caption"
				classList="caption !mb-5"
				text="Sorry, you don't have permission to access this page, please contact the developers"></TextWrapper>
			<Link to={'/'}>
				<ButtonWrapper
					label="Back to Home"
					endIcon={<ArrowForwardIcon></ArrowForwardIcon>}></ButtonWrapper>
			</Link>
		</Box>
	);
};
